import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { AxiosResponseCustom, ResponseCommonKeys, useRestAPI } from "./axiosAPI"
import { useState } from "react"
import { backendPagination } from "src/types/pagination"
import { AxiosProgressEvent } from "axios"



export function useSecondarySalesData({
    retryCount,
}: {
    retryCount?: number,
}) {

    const api = useRestAPI()
    const [totalSubAttributeCount, setTotalSubAttributeCount] = useState(0)
    const [validateProgress,setValidateProgress] = useState(0)
    const [uploadProgress,setuploadProgress] = useState(0)
    const queryclient = useQueryClient()
    // const [deleteRetryCount,setDeleteRetryCount] = useState(0)

    const { mutateAsync: validateSecondarySalesDataExel, isPending: isvalidateingSecondarySalesDataExel, failureCount: validateSecondarySalesDataExelFailureCount, isError: isvalidateSecondarySalesDataExelError } = useMutation({
        mutationFn: async ({ file }: { file: File }):Promise<ResponseCommonKeys&{errors?:any}> => {

            const formData = new FormData();
            formData.append('file', file);

            const response = await api.post({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/secondary-sales-actual-data/validate/`,
                mode: 'protected',
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total!
                    );
                    setValidateProgress(percentCompleted);
                },
                data: formData
            });


            if (response.success === false) {

                // setDeleteRetryCount((prev)=>prev+1)
                return response
            }


            return response
        },
        retry: 4,

    })

    const { mutateAsync: uploadSecondarySalesDataExel, isPending: isUploadingSecondarySalesDataExel, failureCount: uploadSecondarySalesDataExelFailureCount } = useMutation({
        mutationFn: async ({ 
            file,
            end_date,
            start_date
         }: { 
            file: File,
            start_date: string,
            end_date: string
         }): Promise<ResponseCommonKeys> => {

            const formData = new FormData();
            formData.append('file', file);
            formData.append('start_date', start_date);  
            formData.append('end_date', end_date);

            const response = await api.post({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/secondary-sales-actual-data/upload/`,
                mode: 'protected',
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total!
                    );
                    setuploadProgress(percentCompleted);
                },
                data: formData,
                
            });

            if (response.success === false) {

                // setDeleteRetryCount((prev)=>prev+1)
                return response
            }

            return response
        },
        retry: 4
    })


    return {

        validateSecondarySalesDataExel,
        isvalidateingSecondarySalesDataExel,
        isvalidateSecondarySalesDataExelError,
        validateProgress,
        uploadProgress,
        uploadSecondarySalesDataExel,
        isUploadingSecondarySalesDataExel,
    }


}




